import classnames from 'classnames';
import React, { forwardRef } from 'react';
import { Transition } from 'react-transition-group';
import PropTypes from 'prop-types';

// eslint-disable-next-line react/display-name
const Accordion = forwardRef(
  (
    {
      open,
      style,
      content,
      timeout = 300,
      children,
      className,
      afterContent,
      beforeContent,
      animationClass,
      forceRenderContent,
      accordionId,
    },
    transitionComponentRef
  ) => (
    <div>
      <Transition in={open} timeout={timeout} key={accordionId}>
        {(state) => (
          <div
            style={style}
            ref={transitionComponentRef}
            className={classnames('new-accordion', className, {
              [animationClass]: animationClass,
              [`${animationClass}-${state}`]: animationClass,
            })}>
            {beforeContent}
            {forceRenderContent || state !== 'exited' ? content || children : null}
            {afterContent}
          </div>
        )}
      </Transition>
    </div>
  )
);

Accordion.propTypes = {
  open: PropTypes.bool.isRequired,
  accordionId: PropTypes.string,
  style: PropTypes.object,
  content: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  timeout: PropTypes.number,
  className: PropTypes.string,
  afterContent: PropTypes.element,
  beforeContent: PropTypes.element,
  animationClass: PropTypes.string,
  forceRenderContent: PropTypes.bool,
};

export default Accordion;
